<template>
  <div style="background-color: rgb(234, 237, 255)" class="mt-4">
    <v-form ref="clienteForm" style="background-color: rgb(234, 237, 255)">
      <v-card outlined class="pa-2 mb-2 rounded-lg">
        <v-row align="stretch" dense>
          <v-col cols="12" md="3" class="text-center py-0" v-if="edit">
            <div class="text-caption mb-2 grey--text text--darken-1">
              Foto de perfil
            </div>
            <v-hover v-slot="{ hover }">
              <v-card
                outlined
                class="mx-auto image-preview-card"
                :class="{ 'elevation-4': hover }"
                max-width="150"
                height="150"
              >
                <v-img
                  :src="avatarUrl"
                  height="100%"
                  width="100%"
                  class="grey lighten-4"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-icon large color="grey lighten-1"
                        >mdi-account-box</v-icon
                      >
                    </v-row>
                  </template>
                  <v-overlay
                    absolute
                    :value="hover"
                    color="primary"
                    opacity="0.5"
                  >
                    <v-btn
                      fab
                      small
                      color="white"
                      @click="
                        dialog = true;
                        index++;
                      "
                    >
                      <v-icon color="primary">mdi-camera</v-icon>
                    </v-btn>
                  </v-overlay>
                </v-img>
              </v-card>
            </v-hover>
            <v-btn
              text
              color="primary"
              small
              class="mt-2 text-none"
              @click="
                dialog = true;
                index++;
              "
            >
              Cambiar Foto
            </v-btn>
          </v-col>
          <v-col cols="12" :md="edit ? 9 : 12" class="py-0">
            <v-row dense class="py-12">
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-if="!edit"
                  v-model="Cliente.Nombres"
                  :rules="Rules.Nombres"
                  label="Nombres"
                  prepend-icon="mdi-alpha-n"
                  outlined
                  hide-details
                  dense
                  required
                ></v-text-field>
                <v-text-field
                  v-if="edit"
                  v-model="Cliente.Nombres"
                  :rules="Rules.Nombres"
                  label="Nombres"
                  prepend-icon="mdi-alpha-n"
                  outlined
                  hide-details
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="Cliente.Apellidos"
                  :rules="Rules.Apellidos"
                  label="Apellidos"
                  prepend-icon="mdi-alpha-a"
                  outlined
                  hide-details
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-switch
                  v-if="edit"
                  label="Bloqueado"
                  v-model="Cliente.blqd"
                  outlined
                  hide-details
                  dense
                  required
                ></v-switch>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-btn
                  @click="sendInstruccionesApp"
                  block
                  color="info"
                  v-if="edit && tenant == 'PCUN'"
                  >Enviar instrucción App</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>

      <v-row dense>
        <v-col cols="12" md="6" class="py-1">
          <v-card outlined class="pa-2 rounded-lg fill-height">
            <v-card-title class="text-overline py-0"
              >DATOS PERSONALES</v-card-title
            >
            <v-card-text class="pt-1 pb-0">
              <v-row dense>
                <v-col cols="12" class="py-1">
                  <v-text-field
                    v-model="Cliente.Apodo"
                    label="Alias (Opcional)"
                    prepend-icon="mdi-account-circle"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <v-select
                    :items="Catalogos.Sexo"
                    v-model="Cliente.Sexo"
                    label="H o M"
                    prepend-icon="mdi-human-male-female"
                    outlined
                    dense
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <!-- <v-text-field
                    v-mask="'####-##-##'"
                    v-model="Cliente.FechaNacimiento"
                    label="Fecha de nacimiento (yyyy/mm/dd)"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                  ></v-text-field> -->
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="Cliente.FechaNacimiento"
                        label="Fecha de nacimiento"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="Cliente.FechaNacimiento"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6" class="py-1">
          <v-card outlined class="pa-2 rounded-lg fill-height">
            <v-card-title class="text-overline py-0">CONTACTO</v-card-title>
            <v-card-text class="pt-1 pb-0">
              <v-row dense>
                <v-col cols="12" class="py-1">
                  <v-text-field
                    v-model="Cliente.Correo"
                    :rules="Rules.Correo" 
                    label="Correo"
                    prepend-icon="mdi-email"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-1">
                  <v-row dense>
                    <v-col cols="12" md="4" class="py-1">
                      <countryCodesSelector v-model="Cliente.CountryCode" />
                    </v-col>
                    <v-col cols="12" md="8" class="py-1">
                      <v-text-field
                        v-model="Cliente.Telefono"
                        label="Telefono"
                        :rules="Rules.Telefono"
                        outlined
                        dense
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6" class="py-1">
          <v-card outlined class="pa-2 rounded-lg fill-height">
            <v-card-title class="text-overline py-0"
              >CLASIFICACIÓN</v-card-title
            >
            <v-card-text class="pt-1 pb-0">
              <v-row dense>
                <v-col cols="12" md="6" class="py-1">
                  <v-autocomplete
                    label="Nacionalidad"
                    prepend-icon="mdi-flag"
                    :items="nacionalidades"
                    outlined
                    v-model="Cliente.ncnl"
                    dense
                    required
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" md="6" class="py-1">
                  <v-autocomplete
                    v-model="Cliente.tipo"
                    :items="grupos"
                    prepend-icon="mdi-view-list"
                    outlined
                    dense
                    chips
                    color="blue-grey lighten-2"
                    label="Grupo Cliente"
                    item-text="name"
                    item-value="name"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        small
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="data.select"
                      >
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" class="py-1">
                  <v-text-field
                    label="Club de origen"
                    prepend-icon="mdi-golf"
                    v-model="Cliente.clor"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6" class="py-1">
          <v-card outlined class="pa-2 rounded-lg fill-height">
            <v-card-title class="text-overline py-0"
              >DATOS DE GOLF</v-card-title
            >
            <v-card-text class="pt-1 pb-0">
              <v-row dense>
                <v-col cols="12" md="6" class="py-1">
                  <v-text-field
                    v-model="Cliente.hdcp"
                    v-mask="'#####'"
                    label="Handicap"
                    prepend-icon="mdi-alpha-h"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="py-1">
                  <v-text-field
                    v-mask="'################'"
                    label="Ghin"
                    v-model="Cliente.ghin"
                    prepend-icon="mdi-numeric"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="py-1">
                  <v-textarea
                    v-if="edit"
                    label="Notas"
                    v-model="Cliente.nots"
                    outlined
                    dense
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-1" justify="end" dense>
        <v-col cols="12" class="text-right">
          <v-btn @click="$emit('toggle', false)">Cancelar</v-btn>

          <v-btn style="margin-left: 6px" color="success" @click="checkForm()"
            >Guardar</v-btn
          >
        </v-col>
      </v-row>
    </v-form>

    <v-dialog :key="index" v-model="dialog" persistent max-width="500">
      <v-card class="rounded-lg">
        <v-card-title class="text-h5"> Cargar imagenes </v-card-title>
        <v-card-text>
          <v-btn @click="$refs.FileInput.click()" x-small color="primary"
            >Seleccionar imagen</v-btn
          >
          <input
            ref="FileInput"
            type="file"
            style="display: none"
            accept="image/png, image/jpeg"
            @change="onFileSelect"
          />
          <vue-cropper
            v-show="imgLoading"
            :aspect-ratio="9 / 9"
            preview=".preview"
            ref="cropper"
            :src="selectedFile"
          ></vue-cropper>
          <v-btn-toggle v-show="imgLoading">
            <v-btn @click="rotate(90)">
              <v-icon>mdi-rotate-left</v-icon>
            </v-btn>

            <v-btn @click="zoom(-0.2)">
              <v-icon>mdi-magnify-minus-outline</v-icon>
            </v-btn>

            <v-btn @click="zoom(0.2)">
              <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="
              dialog = false;
              imgLoading = false;
            "
          >
            Cancelar
          </v-btn>
          <v-btn
            :loading="loaderImage"
            color="green darken-1"
            text
            @click="saveImage()"
          >
            Subir foto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      :key="indexReactivar"
      v-model="dialogReactivar"
      persistent
      max-width="500"
    >
      <v-card class="rounded-lg">
        <v-card-title class="text-h5"> Reactivar cliente </v-card-title>
        <v-card-text>
          El cliente que intentas crear esta desactivado, deseas reactivarlo?
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="loadingReactivando"
            @click="reactivarJugador"
            color="success"
            >Activar cliente</v-btn
          >
          <v-btn
            :loading="loadingReactivando"
            @click="dialogReactivar = false"
            color="error"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.image-preview-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 2px dashed #e0e0e0 !important;
}

.image-preview-card:hover {
  border-color: var(--v-primary-base) !important;
}

.select2-container {
  width: 100% !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
//const $ = require('jquery');
//window.$ = $;

import moment from "moment";
import Cliente from "../../../clases/Cliente.js";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import countryCodesSelector from "../../MainComponents/CountryCodeSelector.vue";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
export default {
  name: "ClienteForm",
  components: { VueCropper, countryCodesSelector },
  props: ["edit", "dataEdit"],
  data() {
    return {
      loadingReactivando: false,
      index: 0,
      playerReactive: null,
      indexReactivar: 1000,
      mime_type: "",
      cropedImage: "",
      autoCrop: false,
      selectedFile: "/assets/img/iconUser.png",
      imgLoading: false,
      loaderImage: false,
      image: "",
      files: "",
      dialog: false,
      dialogReactivar: false,
      avatarUrl: require("@/assets/img/iconUser.png"),
      nacionalidades: [],
      grupos: [],
      menu: false,
      Cliente: Cliente.getPropertyModel(),
      Rules: Cliente.getRules(),
      errors: {},
      loader: true,
      Catalogos: {
        GruposCliente: [],
        Sexo: [
          { value: "H", text: "H" },
          { value: "M", text: "M" },
        ],
      },
    };
  },
  methods: {
    getImg(imgUrl) {
      let app = this.$store.getters.getFirebaseApp;
      const storage = getStorage(app.mainApp);
      getDownloadURL(ref(storage, imgUrl))
        .then((url) => {
          this.avatarUrl = url;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    saveImage() {
      this.loaderImage = true;
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        const formData = new FormData();
        formData.append("ClienteId", this.Cliente.Id);
        formData.append("Tenant", this.$store.getters.getFirebaseApp.tenant);
        formData.append("Avatar", blob, "Avatar.jpg");

        this.$store.getters.getFirebaseApp.fba
          .callForm("PDV-Clientes-uploadAvatar", formData, {
            "Content-Type": "multipart/form-data",
          })
          .then((result) => {
            if (result.data.ok) {
              this.$emit("toggle", false);
              this.loaderImage = false;
            }
            this.loaderImage = true;
          })
          .catch((error) => {
            this.$swal.showValidationMessage(`Request failed: ${error}`);
            this.loaderImage = true;
          });
      }, this.mime_type);
    },
    onFileSelect(e) {
      const file = e.target.files[0];
      this.mime_type = file.type;

      if (typeof FileReader === "function") {
        this.dialog = true;
        const reader = new FileReader();
        reader.onload = (event) => {
          this.selectedFile = event.target.result;

          this.imgLoading = true;
          this.$refs.cropper.replace(this.selectedFile);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    beforeUpload(image) {
      this.getBase64(image, (imageUrl) => {
        this.imageUrl = imageUrl;
        this.dialog = true;
      });

      return false;
    },
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));

      reader.readAsDataURL(img);
    },
    async getNacionalidades() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("PGS_Catalogos", "Nacionalidades");
      const data = await firestore.getDoc(doc);
      let nacionalidades = [];
      let documentoNac = data.data();
      documentoNac.Data.forEach((nac) => {
        nacionalidades.push(nac);
      });
      documentoNac.Frcn.forEach((fr) => {
        nacionalidades.unshift(documentoNac.Data[fr]);
      });
      this.nacionalidades = nacionalidades;
    },
    async getUserGroups() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_GruposCliente", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant,
        ),
      ]);

      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      let gps = [];
      if (document) {
        document.forEach((doc) => {
          if (doc.gps) {
            let grupos = Object.entries(doc.gps);
            grupos.forEach((element) => {
              if (element[1]) {
                gps.push({
                  name: element[0],
                });
              }
            });
            this.grupos = gps;
          }
        });
      }
    },
    checkForm() {
      if (this.$refs.clienteForm.validate()) {
        if (this.edit) {
          this.editarClient(this.Cliente);
        } else {
          this.createClient(this.Cliente);
        }
      }
    },
    async reactivarJugador() {
      this.loadingReactivando = true;
      await this.$store.getters.getFirebaseApp.fba
        .call("PDV-Clientes-reactivarCliente", { Id: this.playerReactive })
        .then((result) => {
          if (result.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "CLIENTE_REACTIVAR",
              Mensaje: "Cliente reactivado",
              reference: { id: this.playerReactive, tp: "CLI-Cliente", al: "CLIENTE" },
              data: { Id: this.playerReactive }
            });
            this.$emit("toggle", false);
            this.dialogReactivar = false;
          } else {
            this.$swal({
              title: "Error reactivando",
              text: result.error,
              icon: "error",
            });
          }
          this.loadingReactivando = false;
        })
        .catch((error) => {
          this.loadingReactivando = false;
          this.$swal({
            title: "Error reactivando",
            text: `Request failed: ${error}`,
            icon: "error",
          });
        });
    },
    sendInstruccionesApp() {
      this.$swal({
        title: "¿Deseas enviar la información de la app al cliente?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Enviar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("APP-Download-downloadAppEmail", {
              app: "-NwuJrV6RoPSJbbuYlCv",
              correo: this.Cliente.Correo,
            })
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "enviado",
              text: "El correo se guardo envio correctamente",
              icon: "success",
            }).then(() => {
              this.$emit("toggle", false);
            });
          } else {
            this.$swal(
              "Error guardando cliente",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },
    createClient(dataCliente) {
      this.$swal({
        title: "¿Deseas guardar la información del cliente?",
        text: "El cliente se guardara y se vinculara al jugador seleccionado",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = dataCliente;
          data.Nombres = data.Nombres.replace(/^\s\s*/, "").replace(
            /\s\s*$/,
            "",
          );
          data.Apellidos = data.Apellidos.replace(/^\s\s*/, "").replace(
            /\s\s*$/,
            "",
          );
          data.Telefonos = [data.Telefono];
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Clientes-createCliente", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            const targetId = (result.value.data && (result.value.data.id || (result.value.data.data && result.value.data.data.id))) || dataCliente.Id || dataCliente.id;
            const clienteName = `${dataCliente.Nombres || ""} ${dataCliente.Apellidos || ""}`.trim();
            this.$pgsHelper.writeLog({
              Evento: "CLIENTE_CREATE",
              Mensaje: `Cliente creado: ${clienteName}`,
              reference: { id: targetId, tp: "CLI-Cliente", al: clienteName || "CLIENTE" },
              data: dataCliente
            });
            this.$swal({
              title: "Guardado",
              text: "El cliente se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.$emit("toggle", false);
            });
          } else {
            if (result?.value?.data?.code == 410) {
              this.playerReactive = result?.value?.data?.extra?.clienteId;
              this.dialogReactivar = true;
            } else {
              this.$swal(
                "Error guardando cliente",
                result.value.data.error,
                "error",
              );
            }
          }
        }
      });
    },
    editarClient(dataCliente) {
      this.$swal({
        title: "¿Deseas guardar la información del cliente?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = dataCliente;
          data.Telefonos = [data.Telefono];
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Clientes-updateCliente", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            const clienteName = `${dataCliente.Nombres || ""} ${dataCliente.Apellidos || ""}`.trim();
            this.$pgsHelper.writeLog({
              Evento: "CLIENTE_EDIT",
              Mensaje: `Cliente editado: ${clienteName}`,
              reference: { id: dataCliente.Id || dataCliente.id, tp: "CLI-Cliente", al: clienteName || "CLIENTE" },
              data: dataCliente
            });
            this.$swal({
              title: "Guardado",
              text: "El cliente se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.$emit("toggle", false);
            });
          } else {
            this.$swal("Error saving client", result.value.data.error, "error");
          }
        }
      });
    },
  },
  computed: {
    tenant() {
      let tenant = this.$store.getters.getFirebaseApp.tenant;
      return tenant;
    },
  },
  watch: {},
  beforeMount: function () {
    this.loader = true;
    this.getUserGroups();
  },
  mounted() {
    this.loader = false;

    if (this.edit) {
      this.Cliente = this.dataEdit;
      this.Cliente.TelefonoAux = this.Cliente.Telefonos[0]
        ? this.Cliente.Telefonos[0]
        : "";
      if (this.Cliente.Telefono == "") {
        this.Cliente.Telefono = this.Cliente.Telefonos[0]
          ? this.Cliente.Telefonos[0]
          : "";
      }
      if (this.Cliente.Avatar) {
        let url =
          this.$store.getters.getFirebaseApp.tenant +
          "/PDV_Clientes/" +
          this.Cliente.Id +
          "/avatar.jpg";
        this.getImg(url);
      }
    } else {
      this.Cliente = new Cliente();
    }

    this.getNacionalidades();
  },
};
</script>
